// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatasusde } from "../../../icons/mono/build/icon-statasusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatasusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatasusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatasusdeIcon.displayName = 'StatasusdeIcon';
}

export default StatasusdeIcon;